import { isPlatformBrowser } from '@angular/common';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);

  const excludedUrls = [
    'api.geoapify.com'
  ];

  const isExcluded = excludedUrls.some(url =>
    req.url.includes(url)
  );

  if (isPlatformBrowser(platformId) && !isExcluded) {
    const token = localStorage.getItem('token');

    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
        
      });
      

    }
  }

  return next(req);
};

